import billingEpics from '../containers/billing/BillingsEpics';

export default [
    ...billingEpics
]


// WEBPACK FOOTER //
// ./src/redux/epics.js